<template>
  <hamv-dialog :dialogProps="dialogProps" :showModal="showModal">
    <span class="el-dialog__title" data-qa="Dialog-DeleteNotification-Title" slot="header">{{ $t('notificationsDeleteDialogTitle') }}</span>
    <span data-qa="Dialog-DeleteNotification-ConfirmText">{{ $t('notificationsDeleteDialogConfirmText') }}</span>
    <div slot="actions">
      <el-button
        @click="closePopup"
        class="btn-close"
        data-qa="Dialog-DeleteNotification-Button-Close"
        type="text"
      >
        {{ $t('notificationsDeleteDialogButtonCancelText') }}
      </el-button>
      <el-button
        @click="deleteNotification(id)"
        :disabled="loading"
        :loading="loading"
        data-qa="Dialog-DeleteNotification-Button-Delete"
        type="warning"
      >
        {{ $t('notificationsDeleteDialogButtonDeleteText') }}
      </el-button>
    </div>
  </hamv-dialog>
</template>

<script>
  import main from './NotificationsDelete.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './NotificationsDelete.scss'
</style>



// WEBPACK FOOTER //
// NotificationsDelete.vue?fb1bb7f6